// AUTO-GENERATED by scripts/sync-api-validation-contracts.mjs
// Source of truth: /API_VALIDATION_CONTRACTS.json
export const API_VALIDATION_CONTRACTS = {
  "schema_version": 1,
  "auth": {
    "login_username": {
      "min_length": 1,
      "max_length": 100
    },
    "username": {
      "min_length": 3,
      "max_length": 100
    },
    "password_input": {
      "min_length": 1,
      "max_length": 256
    },
    "new_password": {
      "min_length": 8,
      "max_length": 256
    },
    "roles": [
      "user",
      "admin"
    ],
    "role_pattern": "^(user|admin)$"
  },
  "settings": {
    "user_name": {
      "min_length": 1,
      "max_length": 150
    }
  },
  "device": {
    "device_id": {
      "min_length": 8,
      "max_length": 64
    },
    "device_name": {
      "min_length": 1,
      "max_length": 160
    },
    "platform": {
      "max_length": 80
    },
    "user_agent": {
      "max_length": 512
    },
    "app_version": {
      "max_length": 32
    }
  },
  "push": {
    "endpoint": {
      "min_length": 1,
      "max_length": 4096
    },
    "p256dh": {
      "min_length": 1,
      "max_length": 512
    },
    "auth": {
      "min_length": 1,
      "max_length": 256
    },
    "device_name": {
      "max_length": 160
    },
    "device_id": {
      "max_length": 64
    },
    "user_agent": {
      "max_length": 512
    },
    "delivery_ack_stages": [
      "service_worker_received",
      "notification_created"
    ],
    "legacy_delivery_ack_stages": [
      "device_received",
      "notification_shown"
    ]
  },
  "storage_ownership": {
    "location_code": {
      "min_length": 1,
      "max_length": 8
    },
    "cabinet_number": {
      "min_length": 1,
      "max_length": 8
    }
  },
  "visual_lab": {
    "profile_name": {
      "min_length": 2,
      "max_length": 120
    },
    "description": {
      "max_length": 1000
    },
    "change_reason": {
      "max_length": 1200
    },
    "release_notes": {
      "max_length": 2000
    },
    "quality_method": {
      "max_length": 40
    },
    "quality_processing_time_ms": {
      "min": 0,
      "max": 600000
    }
  },
  "vision_optimizer": {
    "profile_name": {
      "min_length": 1,
      "max_length": 64
    },
    "profile_description": {
      "max_length": 240
    },
    "job_limit": {
      "min": 1,
      "max": 5000
    },
    "sweep_values_max_items": 64,
    "optuna_trials": {
      "min": 1,
      "max": 500
    },
    "cnn_epochs": {
      "min": 1,
      "max": 100
    },
    "fast_path_confidence_threshold": {
      "min": 0.5,
      "max": 0.99
    },
    "search_space_keys_max_items": 128,
    "learning_focus_key_max_length": 240,
    "optimizer_search_quality_version_max_length": 64,
    "cnn_input_scale": {
      "min": 0.5,
      "max": 1.5
    },
    "live_confidence_threshold": {
      "min": 0.05,
      "max": 0.99
    }
  }
} as const;
